export const useCustomLayout = () => {
  const hostname = window.location.hostname;

  try {
    const raw = localStorage.getItem('user');
    const data = JSON.parse(raw);
    const extId = Number(data?.ext_headoffice_id);

    if (hostname === "lk.ecvi.ru" && extId === 21) return 'intermark'
    if (hostname === "lk-shermont.ru") return 'shermont'
    //if (hostname === "localhost") return 'shermont'
    return null;

  } catch (e) {
    console.error('Ошибка парсинга localStorage', e);
    return false;
  }
};